import { typeReportsColumnDataType } from "./reports-filter.models";
export interface IReportsColumnModel {
    id: number;
    field: string;
    groupField?: string;
    groupType?: 'sum' | 'variationPercentage';
    // name?: string;
    header?: string;
    dataType: typeReportsColumnDataType;
    popupLinkObject?: { idColumn: string, module: string, data?: any };
    isShow?: boolean;
    fieldNameDB?: string;
    fieldDataType?: string;
    isCustom?: boolean;
    isCommaSeperated?: boolean;
    isCsv?: boolean;
    isDateWithTime?: boolean;
}

export interface IPopupLink {
    rowData: any;
    col: IReportsColumnModel;
}

export const ReportsPermissionNames = {
    Customers: "Customers",
    Invoices: "Invoices",
    SalesOrder: "Sales Order",
    openSalesOrders: "Open Sales Order",
    backSalesOrders: "Sales Back Order Report",
    salesOrderCommited: "Sales Order Committed Report",
    inventoryallinvoice: "All Invoices Report",
    invoiceByRep: "Invoices by Reps",
    invoiceByCustomer: "Invoices by Customer",
    profitByRep: "Invoice Profitability by Sales Rep",
    profitByCustomer: "Invoice Profitability by Customer",
    inventoryopeninvoice: "Open Invoices Report",
    accountsReceivable: "Accounts Receivable",
    Vendor: "Vendor",
    accountsPayable: "Accounts Payable Report",
    profitability: "Inventory Profitability Report",
    inventoryValuationSummary: "Inventory Valuation Summary",
    inventoryValuationDetail: "Inventory Valuation Detail",
    inventorySnapshot: "Current Inventory Snapshot",
    shipping: "Shipping Report",
    picktimebypicker: "Avg Pick-time By Picker",
    picktimebylocation: "Avg Pick-time By Location",
    packtimebypacker: "Avg Pack-time By Packer",
    packtimebylocation: "Avg Pack-time By Location",
    inventoryAging :"Inventory Aging Report"
} as const;


export const ReportsActivityRoutes = {
    activityAnalyticReportSummary: "analytic-summary",
    activityAnalyticReportDetail: "analytic-detail",
    outboundCallReport: "outbound-call",
    outboundCallRequired: "outbound-call-required",
    inboundCallReport: "inbound-call",
    top10ActivityUser: "top-activity-user",
} as const;
export type typeReportsActivityRoutes = typeof ReportsActivityRoutes[keyof typeof ReportsActivityRoutes];

export const ReportsAccountRoutes = {
    accountsActivityReport: "activity",
    accountsNoActivityReport: "no-activity",
    keyAccountsReportSummary: "key-accounts-summary",
    keyAccountsReportDetails: "key-accounts-details"
} as const;
export type typeReportsAccountRoutes = typeof ReportsAccountRoutes[keyof typeof ReportsAccountRoutes];

export const ReportsCaseRoutes = {
    casesByCategorySummary: "category-summary",
    casesByCategoryDetails: "category-details",
    casesByRepSummary: "rep-summary",
    casesByRepDetails: "rep-details",
    casesBySourceSummary: "source-summary",
    casesBySourceDetails: "source-details",
    casesByAccounts: "accounts",
    casesByLeads: "leads",
} as const;
export type typeReportsCaseRoutes = typeof ReportsCaseRoutes[keyof typeof ReportsCaseRoutes];

export enum ReportsAuditRoutes {
    'audit-report' = "audit-report",
}
